module.exports = __webpack_public_path__ + "img/FB-cover-photo-03.e20eed0e.webp";